import React, { Fragment, useEffect, useRef } from 'react'
import cn from 'classnames'
import Divider from '@ui/Divider'
import Section from '@ui/Section'
import Tags from '@ui/Tags'

export default function Question({
  header,
  className,
  topContent = null,
  children,
  bottomContent,
  title,
  titlePlaceholder,
  titleTranslationTooltip,
  titleRequired,
  titleEditable,
  description,
  descriptionPlaceholder,
  descriptionTranslationTooltip,
  descriptionRequired,
  descriptionEditable,
  classNameContent,
  onBlur,
  mode,
  textDirection = 'ltr',
  variablesOptions,
  size = '',
  tags = [],
  isSurvey = false,
  autoScroll
}) {
  const showHeader = !isSurvey && header && (header.title || header.description)
  const questionRef = useRef()

  useEffect(() => {
    const question = questionRef.current
    if (autoScroll > 0 && question) {
      question.scrollTo({ top: question.scrollHeight, behavior: 'smooth' })
    }
  }, [autoScroll])

  return (
    <div ref={questionRef} className={cn('question-container', className, mode)}>
      {showHeader && (
        <Fragment>
          <Section
            size='h3'
            title={header.title}
            titlePlaceholder={header.titlePlaceholder}
            titleTranslationTooltip={header.titleTranslationTooltip}
            titleRequired={header.titleRequired}
            titleEditable={header.titleEditable}
            description={header.description}
            descriptionPlaceholder={header.descriptionPlaceholder}
            descriptionTranslationTooltip={header.descriptionTranslationTooltip}
            descriptionRequired={header.descriptionRequired}
            descriptionEditable={header.descriptionEditable}
            onBlur={header.onBlur}
            mode={mode}
            className='question-header'
            textDirection={textDirection}
            variablesOptions={variablesOptions}
          />
          <Divider className='big extra-soft' />
        </Fragment>
      )}
      {topContent}
      {tags.length > 0 && (
        <Fragment>
          <Tags tags={tags} color='white' className='mb-8' />
          <Divider hidden className='x4' />
        </Fragment>
      )}
      <Section
        size={size || 'h2'}
        title={title}
        titlePlaceholder={titlePlaceholder}
        titleTranslationTooltip={titleTranslationTooltip}
        titleRequired={titleRequired}
        titleEditable={titleEditable}
        description={description}
        descriptionPlaceholder={descriptionPlaceholder}
        descriptionTranslationTooltip={descriptionTranslationTooltip}
        descriptionRequired={descriptionRequired}
        descriptionEditable={descriptionEditable}
        onBlur={onBlur}
        className={cn('question-content', classNameContent)}
        mode={mode}
        textDirection={textDirection}
        variablesOptions={variablesOptions}
      >
        <div className='question-content__children'>{children}</div>
      </Section>
      {bottomContent}
    </div>
  )
}
